<template>
    <textarea :placeholder="placeholder" :value="value" rows="3" :disabled="disabled" :required="required"
        @input="$emit('input', $event.target.value)"
        class="tw:w-full tw:px-3 tw:py-2.5 tw:rounded-xl tw:border tw:border-slate-200 tw:text-xs tw:text-slate-700 focus:tw:outline-none focus:tw:border-emerald-600"></textarea>
</template>

<script>
export default {
    name: 'BaseTextArea',
    props: {
        // En Vue 2, v-model pasa automáticamente una prop llamada "value"
        value: {
            type: [String, Number],
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        }
    }
}
</script>